import { useState, useEffect } from 'react';
import pharmacy from 'services/pharmacy';
import { useHistory } from 'react-router-dom';

export default () => {
  const [consents, setConsents] = useState({});
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    const getConsents = async () => {
      try {
        const response = await pharmacy.get(`/coopuser/consent`, {
          headers: { 'api-version': 'v2' },
        });
        setConsents(response.data);
        setLoading(false);
      } catch (e) {
        setLoading(false);
        history.push('/pharmacy/error');
      }
    };

    getConsents();
  }, [history]);

  const putConsents = async (consents) => {
    try {
      await pharmacy.patch(`/coopuser/consent`, consents);
      history.push('/pharmacy/dashboard/account');
    } catch (e) {
      history.push('/pharmacy/error');
    }
  };

  return [consents, loading, putConsents];
};
